import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';

/** Attend le verdict de session : jamais de redirection tant que le service est indisponible. */
export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenVerdict();
  return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
};
